<div id="notes-container">
  @if (loading) {
    <div class="overlay full"  id="project-notes-loadingSpinner">
      <p class="text-center">{{ appStrings.pleaseWait }}</p>
      <ds-progress-spinner id="loading" progress_mode="indeterminate"></ds-progress-spinner>
    </div>
  }
  @for (note of notes; track note; let index = $index) {
    <div class="note" [id]="'note'+index">
      <ds-paper
        id="notePaper"
        elevation="elevation_none"
        borderRadius="radius_S"
        outline="outlined"
        insidePaddingTop="top-spacing_XL"
        insidePaddingBottom="bottom-spacing_XL"
        insidePaddingLeft="left-spacing_L"
        insidePaddingRight="right-spacing_L"
        >
        <div class="note-content" id="note-content">
          <typography id="authorDate" variant="mat-caption-1" weight="bold" class="row">{{note.author}} - {{ note.date | date:dateTimeFormat }}</typography>
          <typography id="noteText" variant="mat-body-2" weight="regular" class="row">{{note.note}}</typography>
        </div>
        <div id="note-actions">
          @if (!isView) {
            <ds-button id="deleteNoteButton" size="medium" type="tertiary" variant="icon-only" icon="delete"
              (onClick)="removeNote(index)" iconStyle="material-icons-outlined" [isDisabled]="note.isPermanent">
            </ds-button>
          }
        </div>
      </ds-paper>
    </div>
  }
  @if (!isView) {
    <div id="new-note" class="new-note">
      @if (!isAddNote) {
        <div id="btn-add-new">
          <ds-button id="addNoteButton" size="medium" type="secondary" variant="label-icon" icon="add" [label]="appStrings.notesWidget_addNote"
            iconPosition="left" iconStyle="material-icons" (onClick)="toggleAddNote()"
          ></ds-button>
        </div>
      }
      @if (isAddNote) {
        <div id="container-add-new">
          <div class="note-container" [formGroup]="form">
            <ds-multiline id="noteInput" label_orientation="vertical-label" [control]="form.controls.note"></ds-multiline>
          </div>
          <div class="actions-container" #buttons>
            <ds-button id="addButton" size="medium" type="primary" variant="label-only" [label]="appStrings.button_add" [attr.type]="submit" (onClick)="addNewNote()"></ds-button>
            <ds-button id="cancelButton" size="medium" type="secondary" variant="label-only" [label]="appStrings.button_cancel" (onClick)="toggleAddNote()"></ds-button>
          </div>
        </div>
      }
    </div>
  }
</div>